<!-- eslint-disable vue/no-v-html -->
<template>
  <div id="page-landingPage" class="d-flex flex-column">
    <header class="pt-lg-6 px-4 mb-lg-4">
      <v-container>
        <v-row>
          <v-col class="align-self-center">
            <v-img class="logo" src="/img/logo.png" :width="xsOnly ? 140 : 150">
              <template #placeholder>
                <div class="logostring" v-html="logostring($appConfig.name)"></div>
              </template>
            </v-img>
          </v-col>

          <v-spacer class="d-none d-md-block"></v-spacer>

          <v-col class="text-right">
            <v-btn href="/sso" rounded outlined>{{ $t('global.login') }}</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </header>

    <v-container id="lp-content" class="my-auto">
      <v-row>
        <v-col cols="12" sm="6" xl="4" offset-xl="2">
          <div class="screen-wrapper">
            <img class="border" :src="require('../../src/assets/img/screen-wrapper.png')" alt="">

            <div v-if="screenshots.length" class="screens">
              <img v-for="screen in screenshots" :key="screen.id" :src="screen.src">
            </div>

            <div v-else class="screen-fallback d-flex flex-column justify-center align-center">
              <div class="text-center">
                <img class="app-icon elevation-5 mb-4" src="/img/app-icon.png" :width="xsOnly ? 60 : 80">

                <v-img class="logo d-none d-sm-block" src="/img/logo.png" width="150" :class="{'w-100': xsOnly}">
                  <template #placeholder>
                    <div class="logostring" v-html="logostring($appConfig.name)"></div>
                  </template>
                </v-img>
              </div>
            </div>
          </div>
        </v-col>

        <v-col class="d-flex flex-column align-center align-sm-start align-self-center text-center text-sm-left" cols="12" sm="6" xl="4">
          <v-img v-if="screenshots.length" class="app-icon elevation-5 mb-12 d-none d-sm-block" src="/img/app-icon.png" width="80"></v-img>

          <p class="text-uppercase subtitle-2 font-weight-bold opacity-60 d-none d-sm-block">{{ $t('landingpage.preHeadline') }}</p>
          <h1 class="text-uppercase font-weight-bold mb-8" :class="smAndUp ? 'display-2' : 'display-1'">{{ $t('landingpage.headline') }}</h1>
          <p class="mb-8">
            <span v-if="!$appConfig.shortDescription">
              {{ $t('landingpage.description') }} <code>$appConfig.shortDescription</code>
            </span>
            <span v-if="$appConfig.shortDescription">{{$appConfig.shortDescription}}</span>
          </p>

          <v-btn href="/sso" class="brand" large>
            <v-img class="mr-3" :src="require('../../src/assets/img/xidras-icon.png')" width="20"></v-img>
            {{ $t('brand.loginWith') }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>

    <v-footer class="mt-auto opacity-60 caption py-8" color="transparent">
      <v-container>
        <v-row>
          <v-col>
            <div class="text-center">Copyright &copy; {{ new Date().getFullYear() }} Xidras GmbH</div>
          </v-col>
        </v-row>
      </v-container>
    </v-footer>
  </div>
</template>

<script>
  export default {
    name: 'LandingPage',

    data() {
      return {
        screenshots: [
          {src: '/assets/img/screenshots/01.png'}
        ]
      };
    },

    computed: {
      smAndUp() {
        return this.$vuetify.breakpoint.smAndUp;
      },

      xsOnly() {
        return this.$vuetify.breakpoint.xsOnly;
      }
    },

    methods: {
      logostring(string) {
        if (!string) {
          return false;
        }

        let array = '';
        array = string.split(' ');

        for (let i = 0; i < array.length; i++) {
          if (Math.abs(i % 2) !== 1) {
            array[i] = `<span class="font-weight-bold">${array[i]}</span>`;
          } else {
            array[i] = `<span class="font-weight-light">${array[i]}</span>`;
          }
        }

        return array.join('');
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '../assets/scss/landingpage.scss';
</style>
